import { SearchKeyword } from "lib/data/transfer";
import { Entry } from "../model/components/entries/Entry";
import { Section } from "../model/components/sections/Section";

export class SearchItem {
	public static readonly $type: string = "SearchItem`1";
	public readonly $type: string = SearchItem.$type;

	public keywords: SearchKeyword[] = [];
	public item!: Section | Entry;
}
